'use client';

import FreestarAdSlot from '@freestar/pubfig-adslot-react-component';
import Script from 'next/script';

interface freeStartProps {
  placementName: string;
}
// http://localhost:3000/blog?googfc
// http://localhost:3000/blog?dfpkey=testads
const FreeStar = ({ placementName }: freeStartProps) => {
  return (
    <>
      {process.env.NODE_ENV === 'development' && (
        <Script id="freestar-config" strategy="afterInteractive">
          {`
            freestar.queue.push(function () {
              googletag.pubads().set('page_url', 'https://signupgenius.com/');
            });
          `}
        </Script>
      )}
      <FreestarAdSlot
        publisher={'signupgenius-com'}
        placementName={placementName}
      />
    </>
  );
};

export default FreeStar;
